import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { createPersonalInfo } from '../../services/Auth/personalInfoService';
import { getDetalleByParametroId } from '../../services/Admin/detalleParametroService';
import ReusableForm from '../../components/ReusableForm';
import projectLogo from '../../public/Logo.png';
import '../styles/FormPageStyles.css';

const RegisterManualStep1 = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombres: '',
    apellidos: '',
    tipoDocumento: '',
    numeroDocumento: '',
    celular: '',
    email: '',
    cargoId: ''
  });
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tiposData = await getDetalleByParametroId(1);
        setTiposDocumento(tiposData || []);
        const cargosData = await getDetalleByParametroId(6);
        setCargos(cargosData || []);
      } catch (err) {
        setError('Error al cargar datos iniciales.');
        setTiposDocumento([]);
        setCargos([]);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    const { nombres, apellidos, tipoDocumento, numeroDocumento, celular, email } = formData;
    if (!nombres || !apellidos || !tipoDocumento || !numeroDocumento || !celular || !email) {
      setError('Todos los campos obligatorios deben completarse.');
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await createPersonalInfo(formData);
      if (result.success) {
        setSuccessMessage('¡Información guardada! Continuando al paso 2...');
        setTimeout(() => navigate('/auth/register-manual/step-2'), 1000);
      } else {
        setError(result.message || 'Error al registrar. Intente de nuevo.');
      }
    } catch (err) {
      setError('Error al enviar el formulario.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const afterButtonLinks = (
    <div className="login-page-links-container">
      <div className="form-link-item">
        <p>
          ¿Ya tienes cuenta? <Link to="/auth/login" className="form-link">Inicia sesión</Link>
        </p>
      </div>
    </div>
  );

  return (
    <ReusableForm
      title="Crear Cuenta - Paso 1"
      imageSrc={projectLogo}
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText={isSubmitting ? 'Guardando...' : 'Continuar'}
      submitButtonDisabled={isSubmitting}
      afterButtonContent={afterButtonLinks}
    >
      <div className="form-group">
        <input type="text" name="nombres" placeholder="Nombres*" value={formData.nombres} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <input type="text" name="apellidos" placeholder="Apellidos*" value={formData.apellidos} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <select name="tipoDocumento" value={formData.tipoDocumento} onChange={handleChange} required>
          <option value="" disabled>Tipo de Documento*</option>
          {tiposDocumento.map(tipo => (
            <option key={tipo.id_detaparametro} value={tipo.id_detaparametro}>{tipo.valor}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <input type="text" name="numeroDocumento" placeholder="Número de Documento*" value={formData.numeroDocumento} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <input type="text" name="celular" placeholder="Celular*" value={formData.celular} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <input type="email" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <select name="cargoId" value={formData.cargoId} onChange={handleChange}>
          <option value="">Cargo (Opcional)</option>
          {cargos.map(cargo => (
            <option key={cargo.id_detaparametro} value={cargo.id_detaparametro}>{cargo.valor}</option>
          ))}
        </select>
      </div>
    </ReusableForm>
  );
};

export default RegisterManualStep1;


